import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation, useParams } from 'react-router-dom';
import EnvSetting from "./EnvSetting";
import EnvHistory from "./EnvHistory";
import EnvMessages from "./EnvMessages";
import {
  checkTemplatePost,
  envelopeDownloadData,
  getEnvelopeSenderList,
  manageEnvelopeDocFormList,
  manageEnvelopeDocumentDetail,
  manageEnvelopeSignDocumentDetail,
  manageEnvelopeFillFormDetail,
  postCloudList,
  userEnvelopeDownloadData,
  viewMangeEnvelope
} from "../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import BulkMessage from "./BulkMessage";
import ApproveRejectSignDoc from "./ApproveRejectSignDoc";
import TransferEnvelope from "./TransferEnvelope";
import CloseEnvelope from "./CloseEnvelope";
import ResendEnvelope from "./ResendEnvelope";
import ViewSignDocument from "./ViewSignDocument";
import { SYNC_STATUS } from "../../../../../configs/AppConfig";
import DownloadDataDoc from "./DownloadDataDoc";

function ViewEnvelope(props) {
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [envelopeData, setEnvelopeData] = useState({});
  const [recipientList, setRecipientList] = useState([]);
  const [currentRecipient, setCurrentRecipient] = useState('');
  const [currentRecipientId, setCurrentRecipientId] = useState(0);
  const [statusList, setStatusList] = useState([]);
  const [docFormList, setDocFormList] = useState({});
  const [downloadDataList, setDownloadDataList] = useState({});
  const [signDocList, setSignDocList] = useState([]);
  const [isDataDownload, setIsDataDownload] = useState(false);
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  const [isEditRequest, setIsEditRequest] = useState(false);
  const [isRefresh, setIsRefresh] = useState(true);
  const [senderList, setSenderList] = useState([]);
  const [isTemplate, setIsTemplate] = useState(false);
  const [syncStatusList, setSyncStatusList] = useState(SYNC_STATUS);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 200);


  const [signDocDetail, setSignDocDetail] = useState({
    id: 0,
    envelope_id: 0,
    recipient_id: 0,
    is_call: false,
    sign_doc_detail: {}
  });
  const [resendEnvelope, setResendEnvelope] = useState({
    envelope_id: 0,
    emails: []
  });
  const [closeEnvelope, setCloseEnvelope] = useState({
    envelope_id: 0,
    recipient_email: '',
    recipient_id: 0
  });

  const DownloadDataModelRef = useRef(null);

  const viewSignDocumentModelRef = useRef(null);
  const approveRejectSignDocumentModelRef = useRef(null);

  useEffect(function () {
    getEnvelopeSenderList()
      .then(response => {
        setSenderList(response.data.data);
      })
      .catch(err => {

      });
  }, []);

  useEffect(function () {
    postCloudList({})
      .then(response => {
        setSyncStatusList(response.data.data);
      })
      .catch(err => {

      });
  }, []);

  useEffect(function () {
    checkTemplatePost({})
      .then(response => {
        setIsTemplate(response.data.is_template);
      })
      .catch(err => {
      });
  }, []);

  useEffect(function () {
    if (id && isRefresh === true) {
      setLoading(true);
      viewMangeEnvelope({ uuid: id })
        .then(response => {
          let data = response.data.data;

          const cleanName = Utils.getCleanEnvelopeName(data.envelope_name, data.is_negotiation);

          data.envelope_name_original = data.envelope_name;
          data.envelope_name = cleanName;

          setEnvelopeData(data);


          let rList = response.data.recipients;
          if (location?.state?.recipient_id) {
            for (let i = 0; i < rList.length; i++) {
              let active = false;
              if (parseInt(location?.state?.recipient_id) === parseInt(rList[i]['id'])) {
                active = true;
              }
              rList[i]['active'] = active;
            }
          }
          setRecipientList(rList);
          if (response.data.recipients.length > 0) {
            if (location?.state?.recipient_id) {
              setCurrentRecipientId(parseInt(location?.state?.recipient_id));
              setCurrentRecipient(location?.state?.recipient_name);
            } else {
              let recipientData = response.data.recipients[0];
              setCurrentRecipient(recipientData.first_name + ' ' + recipientData.last_name);
              setCurrentRecipientId(parseInt(recipientData.id));
            }
          }
          setIsDownloadFile(response.data.data.is_download_files);
          setIsRefresh(false);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
          navigate('/manage');
        });
    }
  }, [id, navigate, isRefresh, location?.state]);

  useEffect(function () {
    if (currentRecipientId > 0) {
      setLoading(true);
      setStatusList([]);
      manageEnvelopeDocFormList({ id: envelopeData.id, recipient_id: currentRecipientId })
        .then(response => {
          let sList = response.data.status_list;
          let sId = 0;
          if (props?.tabType) {
            if (props?.tabType !== 'message') {
              for (let s = 0; s < sList.length; s++) {
                let isActive = false;
                if (parseInt(sList[s]['id']) === parseInt(props.tabType)) {
                  sId = parseInt(sList[s]['id']);
                  isActive = true;
                }
                sList[s]['active'] = isActive;
              }
            }
          }

          setStatusList(sList);
          setDocFormList({
            sign_doc_list: response.data.signDocList
          });
          setSignDocList(response.data.signDocList)
          setIsDataDownload(response.data.is_data_download);
          setLoading(false);
        })
        .catch(err => {
          setLoading(false);
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [currentRecipientId, envelopeData, props?.tabType]);

  const handleRecipient = (e, data) => {
    e.preventDefault();
    let list = [...recipientList];
    for (let i = 0; i < list.length; i++) {
      let active = false;
      if (data.id === list[i]['id']) {
        active = true;
        setCurrentRecipient(data.first_name + ' ' + data.last_name);
        setCurrentRecipientId(parseInt(data.id));
      }
      list[i]['active'] = active;
    }
    setRecipientList(list);
  };

  const handleStatus = (e, data) => {
    e.preventDefault();
    let list = [...statusList];
    for (let i = 0; i < list.length; i++) {
      let active = false;
      if (parseInt(list[i]['id']) === parseInt(data.id)) {
        active = true;
      }
      list[i]['active'] = active;
    }
    setStatusList(list);

    handleDocFormByStatus(data.id);
  };

  const handleDocFormByStatus = (statusId) => {
    let dataList = { ...docFormList };
    let signDocumentList = dataList.sign_doc_list;
    if (parseInt(statusId) === 0) {
      setSignDocList(signDocumentList);
    } else {
      let sdList = [];



      if (signDocumentList.length > 0) {
        for (let k = 0; k < signDocumentList.length; k++) {
          if (parseInt(signDocumentList[k]['status_id']) === parseInt(statusId)) {
            sdList.push(signDocumentList[k]);
          }
        }
      }

      setSignDocList(sdList);
    }
  };

  const onEnvelopeClose = (e) => {
    e.preventDefault();

    setCloseEnvelope({
      envelope_id: envelopeData.id,
      recipient_id: 0
    });
  };

  const onEnvelopeTransfer = (e) => {
    e.preventDefault();

    setCloseEnvelope({
      envelope_id: envelopeData.id,
      recipient_id: 0
    });
  };

  const onEnvelopeResend = (e, type) => {
    e.preventDefault();

    if (type === 1) {
      let emails = [];

      for (let i = 0; i < recipientList.length; i++) {
        emails.push({
          id: recipientList[i]['id'],
          email: recipientList[i]['email'],
          name: recipientList[i]['first_name'] + ' ' + recipientList[i]['last_name']
        });
      }

      setResendEnvelope({
        envelope_id: envelopeData.id,
        emails: emails
      });
    } else {
      let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
      if (index > -1) {
        setResendEnvelope({
          envelope_id: envelopeData.id,
          emails: [{
            id: currentRecipientId,
            email: recipientList[index]['email'],
            name: recipientList[index]['first_name'] + ' ' + recipientList[index]['last_name']
          }]
        });
      }
    }
  };

  const onRecipientCloseEnvelope = (e) => {
    e.preventDefault();

    let email = '';
    let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
    if (index > -1) {
      email = recipientList[index]['email'];
    }

    setCloseEnvelope({
      envelope_id: envelopeData.id,
      email: email,
      recipient_id: currentRecipientId
    });
  };


  const downloadAllFileForm = (e) => {
    e.preventDefault();
    setLoading(true);
    let obj = {
      envelope_id: parseInt(envelopeData.id),
    };

    userEnvelopeDownloadData(obj)
      .then(res => {
        setDownloadDataList(res.data.data);
        DownloadDataModelRef?.current.click();
        setLoading(false);
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };




  const handleCustomerPortal = (e) => {
    e.preventDefault();

    let index = recipientList.findIndex(x => parseInt(x.id) === parseInt(currentRecipientId));
    if (index > -1) {
      window.open('/client-portal/sleeve/view/' + envelopeData.uuid + '-.' + recipientList[index]['generated_id'], "_blank");
    } else {
      toast.error('Oops...something went wrong. Please try again.');
    }
  };

  const handleExpireDoc = (e) => {
    e.preventDefault();
    navigate('/manage/' + id + '/expired-document');
  };

  const onViewApproveRejectSignDoc = (e, data) => {
    e.preventDefault();
    setLoading(true);
    let obj = {
      id: data.id,
      envelope_id: envelopeData.id,
      recipient_id: currentRecipientId,
    };
    manageEnvelopeSignDocumentDetail(obj)
      .then(response => {
        setSignDocDetail({
          id: data.id,
          envelope_id: envelopeData.id,
          recipient_id: currentRecipientId,
          is_call: true,
          sign_doc_detail: response.data.data
        });

        setLoading(false);
        viewSignDocumentModelRef?.current.click();
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };

  const handleApproveRejectSignDoc = (e, data) => {
    e.preventDefault();
    setLoading(true);
    let obj = {
      id: data.id,
      envelope_id: envelopeData.id,
      recipient_id: currentRecipientId
    };
    manageEnvelopeSignDocumentDetail(obj)
      .then(response => {
        setSignDocDetail({
          id: data.id,
          envelope_id: envelopeData.id,
          recipient_id: currentRecipientId,
          is_call: true,
          sign_doc_detail: response.data.data
        });
        setLoading(false);
        approveRejectSignDocumentModelRef?.current.click();
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        setLoading(false);
      });
  };


  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section className="main_wrapper section-bg-color setting_tab sleeve_info client_portal" style={{ minHeight: "100vh" }}>
        <div className="custom_container">
          <h2 className="sleeve-header mb-3 d-flex align-items-center justify-content-between bread_crumb flexWrap text-white"
          >
            <span>
              <NavLink to={"/manage"} className="text-white fs-3">Contract</NavLink>
              <i className="bi bi-chevron-double-right mx-3" />
              {Utils.getCleanEnvelopeName(envelopeData.envelope_name, envelopeData.is_negotiation)}
            </span>
            <div className="d-flex align-items-baseline">
              {/* {parseInt(envelopeData.status_id) === 2 && parseInt(envelopeData.expired_day) > 0 && (
                <button type="button" onClick={handleExpireDoc}
                  className="btn shadow load_template_btn me-3 text-primary">
                  Request Expired Docs
                </button>
              )} */}
              {isDownloadFile === true && (
                <button type="button" className="btn shadow me-3 bg-light"
                  data-toggle="tooltip"
                  onClick={(e) => downloadAllFileForm(e)}
                  data-placement="right" title="" data-bs-original-title="click to Download">
                  <i className="bi bi-download me-2" aria-hidden="true" /> Download All Files
                </button>
              )}
              <div className="sleeve-dropdown">
                <div className="dropdown">
                  <span className="dots-button menu-toggle bg-white rounded" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="bi bi-three-dots-vertical cursor-pointer" />
                  </span>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li onClick={(e) => onEnvelopeResend(e, 1)} data-bs-toggle="modal"
                      data-bs-target="#resendEnvelope">
                      <div className="dropdown-item">
                        <i className="bi bi-arrow-repeat me-2"></i>
                        Resend Contract</div>
                    </li>
                    <li onClick={onEnvelopeClose} data-bs-toggle="modal"
                      data-bs-target="#closeEnvelope">
                      <div className="dropdown-item">
                        <i className="bi bi-check-circle me-2"></i>
                        Complete Contract</div>
                    </li>
                    <li onClick={onEnvelopeTransfer} data-bs-toggle="modal"
                      data-bs-target="#transferEnvelope">
                      <div className="dropdown-item">
                        <i className="bi bi-arrow-right-circle me-2"></i>
                        Transfer Contract</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </h2>

          {!isEditRequest &&
            <>
              <div className="nav nav-tabs sleeve-tabs gap-2" id="nav-tab" role="tablist">
                <button className={`nav-link border-0 ${props.tabType === 'message' ? `` : `active`}`}
                  id="document-form" data-bs-toggle="tab"
                  data-bs-target="#document-form-detail" type="button" role="tab"
                  aria-controls="document-form-detail" aria-selected="true">Documents & Information
                </button>
                <button className={`nav-link border-0 ${props.tabType === 'message' ? `active` : ``}`}
                  id="messages-tab" data-bs-toggle="tab" data-bs-target="#messages"
                  type="button" role="tab" aria-controls="messages" aria-selected="false">Messages
                  {envelopeData.is_message === true && (<span className="red_dot" />)}
                </button>
                <button className="nav-link border-0" id="History-tab" data-bs-toggle="tab" data-bs-target="#History"
                  type="button" role="tab" aria-controls="History" aria-selected="false">History
                </button>
                <button className="nav-link border-0" id="EnvSetting-tab" data-bs-toggle="tab"
                  data-bs-target="#EnvSetting" type="button" role="tab" aria-controls="EnvSetting"
                  aria-selected="false">Contract Settings
                </button>
              </div>

              <div className="tab-content envelope-tab-content" id="nav-tabContent">
                <div className={`tab-pane fade p-4 bg-light ${props.tabType === 'message' ? `` : `active show`}`}
                  id="document-form-detail" role="tabpanel" aria-labelledby="document-form">
                  <div className="row">
                    {/* Recipients Sidebar - Redesigned */}
                    <div className="col-xxl-3 col-lg-4 col-md-12">
                      <div className="recipients-sidebar p-3">
                        <h6 className="sidebar-title mb-3">
                          <i className="bi bi-people me-2"></i>
                          Collaborators
                        </h6>
                        <div className="recipients-list">
                          {recipientList.map((item, index) => (
                            <div key={index} className={`recipient-item ${item.active ? 'active' : ''}`}
                              onClick={(e) => handleRecipient(e, item)}>
                              <div className="recipient-avatar">
                                <i className="bi bi-person-circle"></i>
                              </div>
                              <div className="recipient-info">
                                <div className="recipient-name">
                                  {item.first_name} {item.last_name}
                                </div>
                                <div className="recipient-count">
                                  {item.total} items
                                </div>
                              </div>
                              {item.active && (
                                <div className="active-indicator">
                                  <i className="bi bi-check-circle-fill text-success"></i>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Main Content Area - Redesigned */}
                    <div className="col-xxl-9 col-lg-8 col-md-12">
                      <div className="content-main p-3">
                        {/* Status Filter Tabs - Redesigned */}
                        {statusList.length > 0 && (
                          <div className="status-filters mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h6 className="mb-0">Filter by Status</h6>
                              <div className="dropdown">
                                <button className="btn btn-outline-secondary btn-sm dropdown-toggle"
                                  type="button" data-bs-toggle="dropdown">
                                  <i className="bi bi-three-dots"></i>
                                </button>
                                <ul className="dropdown-menu">
                                  <li>
                                    <button className="dropdown-item" onClick={handleCustomerPortal}>
                                      <i className="bi bi-eye me-2"></i>
                                      View Client Portal for {currentRecipient}
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item" onClick={(e) => onEnvelopeResend(e, 2)}>
                                      <i className="bi bi-arrow-repeat me-2"></i>
                                      Resend contract to {currentRecipient}
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item" onClick={onRecipientCloseEnvelope}>
                                      <i className="bi bi-check-circle me-2"></i>
                                      Complete contract for {currentRecipient}
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <div className="status-tabs">
                              {statusList.map((item, index) => (
                                <button key={index}
                                  onClick={(e) => handleStatus(e, item)}
                                  className={`status-tab ${item.active ? 'active' : ''}`}>
                                  <span className="status-name">{item.name}</span>
                                  <span className="status-count">({item.total})</span>
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Content Sections - Redesigned */}
                        <div className="content-sections">
                          {signDocList.length > 0 && (
                            <div className="content-section mb-4">
                              <div className="section-header mb-3">
                                <h5 className="mb-0">
                                  <i className="bi bi-pen me-2 text-warning"></i>
                                  Sign Contract
                                </h5>
                              </div>
                              <div className="table-container">
                                <div className="table-responsive">
                                  <table className="table table-modern">
                                    <thead>
                                      <tr>
                                        <th className="document-name-header">
                                          contract Name
                                        </th>
                                        <th className="text-center action-header">
                                          Preview
                                        </th>
                                        <th className="status-header">
                                          Status
                                        </th>
                                        <th className="text-center action-header">
                                          Actions
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {signDocList.length === 0 ? (
                                        <tr>
                                          <td colSpan="4" className="text-center py-4">
                                            <div className="empty-state">
                                              <i className="bi bi-inbox text-muted" style={{ fontSize: '2rem' }}></i>
                                              <p className="text-muted mb-0 mt-2">No sign contracts available</p>
                                            </div>
                                          </td>
                                        </tr>
                                      ) : (
                                        signDocList.map((item, index) => (
                                          <tr key={index} className="document-row">
                                            <td className="document-info">
                                              <div className="document-details">
                                                <div className="document-icon">
                                                  <i className="bi bi-file-earmark-signature text-primary"></i>
                                                </div>
                                                <div className="document-text">
                                                  <div className="document-name">{item.doc_name}</div>
                                                  {item.notes && (
                                                    <div className="document-notes">
                                                      <i className="bi bi-exclamation-triangle text-warning me-1"></i>
                                                      <span className="notes-text">
                                                        <strong>Decline Reason:</strong> {item.notes}
                                                      </span>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </td>

                                            <td className="text-center">
                                              {((item.status_id > 1) && (item.status_id !== 5)) ? (
                                                <button
                                                  className="btn btn-action btn-preview"
                                                  onClick={(e) => onViewApproveRejectSignDoc(e, item)}
                                                  title="View Document"
                                                >
                                                  <i className="bi bi-eye"></i>
                                                </button>
                                              ) : (
                                                <span className="text-muted">-</span>
                                              )}
                                            </td>

                                            <td>
                                              <div className="status-wrapper">
                                                <span className={`status-badge status-${item.status_id}`}>
                                                  {item.status_id === 1 ? (
                                                    <>
                                                      <i className="bi bi-clock me-1"></i>
                                                      Awaiting Sign
                                                    </>
                                                  ) : item.status_id === 2 ? (
                                                    <>
                                                      <i className="bi bi-check-circle me-1"></i>
                                                      Received
                                                    </>
                                                  ) : item.status_id === 5 ? (
                                                    <>
                                                      <i className="bi bi-x-circle me-1"></i>
                                                      Declined
                                                    </>
                                                  ) : item.status_id === 3 ? (
                                                    <>
                                                      <i className="bi bi-check-circle-fill me-1"></i>
                                                      Approved
                                                    </>
                                                  ) : (
                                                    <>
                                                      <i className="bi bi-x-circle-fill me-1"></i>
                                                      Rejected
                                                    </>
                                                  )}
                                                </span>
                                              </div>
                                            </td>

                                            <td className="text-center">
                                              {item.status_id !== 5 ? (
                                                <button
                                                  className="btn btn-action btn-primary-action"
                                                  onClick={(e) => handleApproveRejectSignDoc(e, item)}
                                                  title="Approve or Reject Document"
                                                >
                                                  <i className="bi bi-check2-all me-1"></i>
                                                  Approve/Reject
                                                </button>
                                              ) : (
                                                <span className="text-muted">No Action</span>
                                              )}
                                            </td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`tab-pane fade p-4 message_accordion ${props.tabType === 'message' ? `active show` : ``}`}
                  id="messages" role="tabpanel" aria-labelledby="messages-tab">
                  <EnvMessages envelopeData={envelopeData} recipientList={recipientList}
                    setLoading={setLoading} />
                </div>

                <EnvHistory envelopeData={envelopeData} />

                <EnvSetting envelopeData={envelopeData} setEnvelopeData={setEnvelopeData}
                  setLoading={setLoading} syncStatusList={syncStatusList} />

              </div>
            </>
          }


        </div>
      </section>

      <BulkMessage recipientList={recipientList} setRecipientList={setRecipientList} envelopeData={envelopeData}
        setLoading={setLoading} />

      <div ref={DownloadDataModelRef} data-bs-toggle="offcanvas" data-bs-target="#DownloadDataDoc"
        aria-controls="DownloadDataDoc" />
      <DownloadDataDoc setLoading={setLoading} downloadDataList={downloadDataList}
        setDownloadDataList={setDownloadDataList} />

      <div ref={viewSignDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#viewSignDocument"
        aria-controls="viewSignDocument" />
      <ViewSignDocument windowHeight={windowHeight} setWindowHeight={setWindowHeight} signDocDetail={signDocDetail} setSignDocDetail={setSignDocDetail} setLoading={setLoading} />

      <div ref={approveRejectSignDocumentModelRef} data-bs-toggle="offcanvas" data-bs-target="#ApproveRejectSignDoc"
        aria-controls="ApproveRejectSignDoc" />
      <ApproveRejectSignDoc signDocDetail={signDocDetail} setSignDocDetail={setSignDocDetail} setLoading={setLoading}
        statusList={statusList} setStatusList={setStatusList} docFormList={docFormList}
        setDocFormList={setDocFormList} signDocList={signDocList} setSignDocList={setSignDocList} />


      <TransferEnvelope closeEnvelope={closeEnvelope} setCloseEnvelope={setCloseEnvelope}
        senderList={senderList} setLoading={setLoading} setIsRefresh={setIsRefresh} />

      <CloseEnvelope closeEnvelope={closeEnvelope} setCloseEnvelope={setCloseEnvelope}
        setLoading={setLoading} />

      <ResendEnvelope resendEnvelope={resendEnvelope} setResendEnvelope={setResendEnvelope}
        setLoading={setLoading} />
    </>
  );
}

export default ViewEnvelope;